var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 .5c5.385 0 10.26 2.183 13.789 5.711A19.439 19.439 0 0 1 39.5 20c0 5.385-2.183 10.26-5.711 13.789A19.439 19.439 0 0 1 20 39.5a19.439 19.439 0 0 1-13.789-5.711A19.439 19.439 0 0 1 .5 20c0-5.385 2.183-10.26 5.711-13.789A19.439 19.439 0 0 1 20 .5z",
    stroke: "#ECECEC",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.36 10v1.224h1.4l-2.732 2.556a5.345 5.345 0 0 0-3.807-1.584 5.34 5.34 0 0 0-4.662 2.717 5.437 5.437 0 0 0-.234-.006c-2.936 0-5.325 2.356-5.325 5.25 0 2.689 2.06 4.911 4.704 5.216V27h-1.86v1.224h1.86V30h1.242v-1.776h1.94V27h-1.94v-1.627a5.337 5.337 0 0 0 4.04-2.68c.078.003.157.005.235.005 2.936 0 5.325-2.356 5.325-5.251 0-.984-.276-1.905-.756-2.693l2.968-2.775v1.52H30V10h-3.64zM16.325 24.184c-2.252 0-4.083-1.806-4.083-4.026 0-2.134 1.692-3.885 3.822-4.018a5.174 5.174 0 0 0-.167 1.307c0 2.362 1.59 4.364 3.77 5.022a4.098 4.098 0 0 1-3.342 1.715zm3.9-2.832c-1.772-.44-3.087-2.024-3.087-3.905 0-.415.065-.816.184-1.194 1.77.44 3.086 2.024 3.086 3.905 0 .415-.065.816-.184 1.194zm1.257.113c.11-.418.167-.856.167-1.307 0-2.362-1.59-4.365-3.769-5.022a4.098 4.098 0 0 1 3.341-1.715c2.252 0 4.083 1.806 4.083 4.026 0 2.134-1.691 3.884-3.822 4.018z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.e9a922b1a12460b4758baafb62782d51.svg";
export { ForwardRef as ReactComponent };